"use client";

import clsx from "clsx";
import React from "react";
import { ControllerFieldState } from "react-hook-form";
import { FormControl, FormItem, FormLabel, FormMessage } from "components/ui/form";
import { Textarea } from "components/ui/textarea";

type TextAreaInputProps = {
  field: any;
  fieldState: ControllerFieldState;
  label?: string;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  onChange?: (value: string) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const TextAreaInput = React.forwardRef(
  (
    { field, fieldState, label, className, inputClassName, onChange, ...rest }: TextAreaInputProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <FormItem className={clsx("relative ", className)}>
        {!!label && (
          <FormLabel className="pointer-events-none cursor-text font-matter text-[16px] text-base-primary">
            {label}
          </FormLabel>
        )}
        <FormControl>
          <Textarea
            ref={ref}
            {...field}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              field.onChange(e.target.value);
              onChange?.(e.target.value);
            }}
            rows={4}
            className={clsx(
              "blank:py-4 mt-1.5 w-full resize-none border border-primary-700 font-matter focus:border-transparent",
              "rounded-lg bg-white text-base text-base-primary outline-none dark:bg-baseinverse-dark-primary",
              "focus:ring-2 focus:ring-primary-700 focus-visible:!ring-2",
              "disabled:cursor-not-allowed disabled:border-neutral-200 disabled:bg-neutral-200 disabled:text-base-disabled",
              inputClassName,
              { "ring-2 ring-red-700 focus:ring-red-700": fieldState.error }
            )}
            {...rest}
          />
        </FormControl>
        <FormMessage className="mb-1.5 mt-2 block text-base font-medium" />
      </FormItem>
    );
  }
);

TextAreaInput.displayName = "TextAreaInput";
export default TextAreaInput;
